import type { AppProps } from 'next/app';
import '../libs/embed-playlist/sass/page_style.scss';

function MyApp({ Component, pageProps }: AppProps) {
  return <Component {...pageProps} />;
}

export default MyApp;
